module.exports = __webpack_public_path__ + "static/media/screen.9ff2fe7e.png";